<template>
    <div class="salary" style="background-color:rgba(180,214,242, 0.2);">
         <h3>家属福利</h3>

        <div class="albums">
         <div  v-for="(item, index) in albums" :key="index" class="album" >
         <img :src="item.url"  alt style="width:100%;height:100%;margin-bottom: 1.3125rem;"/>
         <span style="color: #1A1A1A;font-size:1.5rem;line-height:3rem;font-weight: bold; ">{{item.title}}</span>
         <div style="height: 1rem;"></div>
         <!-- <div v-html="item.desc" style="font-size:1.5rem;line-height:2.25rem;color:#777777;margin-top: 1.25rem;margin-bottom: 3.3125rem;"></div>    -->
         </div>
         </div>
    </div>
</template>

<style scoped>

h3 {
  padding-top: 4.375rem;
  padding-bottom: 3.125rem;
  color: #1A1A1A;
  font-size: 2.25rem;
  line-height: 3.75rem;
}

.albums{
  text-align: center;
  padding-bottom: 4.375rem;
}
.album{
  width: 40.625rem;
  height: fit-content;
  /* border: 1px solid #EEEEEE;   */
  display:inline-block;
  text-align: center;
  justify-content: center;
  background-color: #ffffff;
  margin-bottom: 3.125rem;
}
</style>

<script>
export default {

    data () {
    return {
     msg: '家属福利',
     albums:[
        { url: require('../../assets/familybenefits/album0.png') ,
          title: '儿童节礼品',
          desc:'六一儿童节来临之际，<br/>公司为员工子女精心挑选并送上节日礼物。'
        },
        { url: require('../../assets/familybenefits/album1.png') ,
          title: '家属保险福利',
          desc:'公司为员工提供补充商业保险福利计划，员工可通过弹性<br/>自选让父母配偶、子女也享受保险福利。'
        },
        { url: require('../../assets/familybenefits/album2.png') ,
          title: '家属体检福利',
          desc:'员工亲人的健康，既是员工的责任和牵挂，也是让员工放<br/>下后顾之忧、安心工作的精神支柱。公司每年为员工提供<br/>了1名家属半价体检的福利。'
        },]
    };
    },
    onActivated (){

    }
}
</script>



// WEBPACK FOOTER //
// src/components/mobile/FamilyBenefits.vue